import { useEffect, useState } from "react";
import { api } from "../../../core/lib/api";
import { Card } from "../../../core/components/ui/card";

interface Event {
  id: string;
  title: string;
  start_at: number;
  end_at: number;
  timezone: string;
  color_label: string | null;
  recurrence: string | null;
  notes: string | null;
}
export function CalendarEvents({ from, to }: { from: Date; to: Date }) {
  const [events, setEvents] = useState<Event[]>([]),
    [failed, setFailed] = useState(false);
  useEffect(() => {
    let current = true;
    api<Event[]>(
      `/api/atelier/events?${new URLSearchParams({ from: from.toISOString(), to: to.toISOString() })}`,
    )
      .then((rows) => {
        if (current) {
          setEvents(rows);
          setFailed(false);
        }
      })
      .catch(() => {
        if (current) {
          setEvents([]);
          setFailed(true);
        }
      });
    return () => {
      current = false;
    };
  }, [from, to]);
  if (failed) return <p role="status">Les événements d’agenda n’ont pas pu être chargés.</p>;
  if (!events.length) return null;
  return (
    <Card title="Événements de la période">
      {events.map((e) => (
        <div key={e.id} style={{ marginBottom: "1rem" }}>
          <strong>{e.title}</strong>
          <p>
            {new Date(e.start_at * 1000).toLocaleString("fr-CA", { timeZone: e.timezone })} →{" "}
            {new Date(e.end_at * 1000).toLocaleString("fr-CA", { timeZone: e.timezone })}
          </p>
          {e.recurrence ? <p>Récurrence relevée : {e.recurrence}</p> : null}
          {e.notes ? <p>{e.notes}</p> : null}
        </div>
      ))}
    </Card>
  );
}
